import { useState, useRef, useEffect } from 'react';
import '~/apps/App.css';
import '~/apps/common.css';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from "@mui/icons-material/Search";
import Form from "~/components/Form.js";
import queryStrBuilder from '~/helpers/queryStrBuilder.js';
import queryStrReader from '~/helpers/queryStrReader.js';
import {useNavigate, useLocation} from "react-router-dom";

function LocalSearch({defaultHits, ...props}) {

    const navigate = useNavigate();
    const location = useLocation();
    const prevLocationProps = useRef({});

    const defaultPage = 1;

    const searchFormRef = useRef(null);
    const textInputRef = useRef(null);

    const defaultState = {
        query: '',
        page: defaultPage,
        configure: {
            hitsPerPage: defaultHits,
        },
    };

    const [query, setQuery] = useState('');
    const [page, setPage] = useState(defaultPage);
    const [configure, setConfigure] = useState({hitsPerPage: defaultHits});

    const handleChange = e => {
        e.preventDefault();
        setQuery(e.currentTarget.value);
    };

    const search = () => {

        let currentState;

        if (query === '') {
            currentState = defaultState;
            setQuery(defaultState.query);
            setPage(defaultState.page);
            setConfigure(defaultState.configure)
        } else {
            currentState = {query, page, configure};
        }

        if (currentState.query !== decodeURIComponent(queryStrReader(location.search).query)){
            navigate({search: queryStrBuilder(currentState)});
        }
        if (textInputRef.current) textInputRef.current.select();
    };

    const resetState = location => {
        const queryStrObj = queryStrReader(location.search);
        if (typeof queryStrObj === 'object') {
            setQuery(queryStrObj.query);
            setPage(queryStrObj.page);
            setConfigure(queryStrObj.configure)
        }
    };

    useEffect(() => {
        if (location && location.search !== prevLocationProps.current.search) {
            resetState(location);
        }
        prevLocationProps.current = location;
    });

    return <Form submit={search} formRef={searchFormRef} noValidate autoComplete="off" >
        <TextField
            name="peopleSearch"
            id="peopleSearch"
            type="search"
            label="Search Name, Title, Phone, Department..."
            className="directorysearch-text-field"
            value={query}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
            slotProps={{
                inputLabel: {className: "text-field-label"},
                input: {
                    endAdornment: <InputAdornment position="end">
                        <IconButton aria-label="Search" onClick={search} size="large">
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>,
                },
                htmlInput: {className: "text-field-input"},
            }}
            inputRef={textInputRef}
        />
    </Form>;
}

export default LocalSearch;